// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"110":"873495a7","310":"fae6a384"}[chunkId] + ".chunk.css";
};